// extracted by mini-css-extract-plugin
export default {"container":"TableLoading-module_container__n7OChk","spinner":"TableLoading-module_spinner__ZyLCje"};